import React from 'react';

import { createRoot, hydrateRoot } from 'react-dom/client';

/* eslint-disable import/no-extraneous-dependencies -- see src/config/parcel-plugins/resolve-platform-workspace.cjs */
/* Placeholder import that'll be replaced with a static import to the consumer's
app's main component. See platform/packages/uip/stub-frontkit-app-component/README.md */
import App from '@atlassian/stub-frontkit-app-component';
/* eslint-enable import/no-extraneous-dependencies */

import { ADSGlobalStyles } from './ads-global-styles';
import { AppWrapper } from './app-wrapper';

const isStatic = typeof window !== 'undefined' && (window as any).IS_STATIC;
const enableADS = !!process.env.__FK_ENABLE_ADS;

const AppWithWrapper = () => (
	<AppWrapper>
		<App />
	</AppWrapper>
);

const AppWithADS = ({ children }: { children: React.ReactNode }) => (
	<ADSGlobalStyles isStatic={isStatic}>{children}</ADSGlobalStyles>
);

const RenderOrHydrate = () => {
	if (enableADS) {
		return (
			<AppWithADS>
				<AppWithWrapper />
			</AppWithADS>
		);
	}

	return <AppWithWrapper />;
};

const renderApp = () => {
	const domNode = document.getElementById('pillar-root') as HTMLElement;
	const MaybeStrictMode = process.env.__FK_REACT_STRICT_MODE ? React.StrictMode : React.Fragment;
	const rootComponent = (
		<MaybeStrictMode>
			<RenderOrHydrate />
		</MaybeStrictMode>
	);

	if (isStatic) {
		const root = createRoot(domNode);
		root.render(rootComponent);
	} else {
		hydrateRoot(domNode, rootComponent);
	}
};

renderApp();
